import styled from 'styled-components';

const TableFooter = styled.div`
  padding: ${(props): string =>
    `${props.theme.spaces.md} ${props.theme.spaces.xl}`};
  display: grid;
  align-items: center;
  grid-template-columns: auto max-content;
  grid-column-gap: ${(props): string => props.theme.spaces.xl};
  background-color: ${(props): string => props.theme.colors.paleBlue};
  position: sticky;
  left: 0;
`;

export { TableFooter };
